export const v4 = (): string => {
  if (typeof crypto !== "undefined" && crypto.randomUUID !== undefined)
    return crypto.randomUUID();

  if (typeof require !== "undefined") {
    // eslint-disable-next-line global-require
    const c = require("crypto");
    return c.randomUUID();
  }

  throw new Error(`No crypto available.`);
};

export const isUUID = (str: string): boolean => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};
